import { Box } from '@wix/design-system';
import {
  SkeletonBar,
  STUDIO_STRIP_BG_COLOR,
  StudioCta,
  useAnonymous,
} from '@wix/package-picker-shared-studio';
import React from 'react';
import WixStudioWordmark from '../../assets/wix-studio-wordmark.svg';
import { StudioPackagePickerModule } from '../../modules/studio-package-picker.module';

const HIGHLIGHT_COUNT = 3;

interface PageSkeletonProps {
  dataHook: string;
  children: React.ReactNode;
}

export const PageSkeleton = ({
  dataHook,
  children,
}: PageSkeletonProps) => {
  const { t } = StudioPackagePickerModule.internals.useTranslations();
  const { isAnonymous } = useAnonymous();

  return (
    <Box dataHook={dataHook} direction="vertical" width="100%" align="center">
      {!isAnonymous && (
        <Box
          width="100%"
          height="56px"
          verticalAlign="middle"
          padding="0 SP8"
          boxSizing="border-box"
        >
          <WixStudioWordmark />
        </Box>
      )}
      <Box width="100%" padding="0 SP8" boxSizing="border-box">
        <Box
          width="100%"
          height="46px"
          align="center"
          verticalAlign="middle"
          borderRadius="6px"
          backgroundColor={STUDIO_STRIP_BG_COLOR}
        >
          <SkeletonBar width="198px" height="12px" />
        </Box>
      </Box>
      <Box
        direction="vertical"
        width="100%"
        maxWidth="1280px"
        align="center"
        padding="0 SP8"
        boxSizing="border-box"
      >
        <Box width="100%" marginTop="32px">
          <Box
            width="100%"
            direction="vertical"
            align="center"
            gap="16px"
            marginTop={isAnonymous ? 'SP3' : '0'}
          >
            <Box width="100%" maxWidth="781px" direction="vertical">
              <SkeletonBar width="100%" height="45px" />
            </Box>
            <Box height="18px" direction="vertical">
              <Box verticalAlign="middle" gap="16px">
                <SkeletonBar width="131px" height="10px" />
                {Array.from({ length: HIGHLIGHT_COUNT }, (_, index) => (
                  <Box
                    key={index}
                    verticalAlign="middle"
                    gap="6px"
                    padding="0 2px"
                  >
                    <SkeletonBar width="12px" height="12px" />
                    <SkeletonBar width="131px" height="10px" />
                  </Box>
                ))}
              </Box>
            </Box>
            {isAnonymous && (
              <Box marginTop="SP2" pointerEvents="none">
                <StudioCta
                  filled
                  size="medium"
                  onClick={() => {}}
                  tabIndex={-1}
                  aria-hidden
                >
                  {t('studio_package_picker.anon.CTA')}
                </StudioCta>
              </Box>
            )}
          </Box>
        </Box>
        {children}
      </Box>
    </Box>
  );
};
